import { render, staticRenderFns } from "./UpdateTaskWeights.vue?vue&type=template&id=2c7c54a7"
import script from "./UpdateTaskWeights.vue?vue&type=script&lang=js"
export * from "./UpdateTaskWeights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports